const footerScripts = () => {

	let loggedInStatus = window.logArr;

	function profit_loader() {
		(function (i, s, o, g, r, a, m) {
			i['ProfitWellObject'] = r; i[r] = i[r] || function () {
				(i[r].q = i[r].q || []).push(arguments)
			}, i[r].l = 1 * new Date(); a = s.createElement(o),
				m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m);
		})(window, document, 'script', 'https://dna8twue3dlxq.cloudfront.net/js/profitwell.js', 'profitwell');
		profitwell('auth_token', '66665ce54419f7ddc01d7d2ac499dfda');
	}
	setTimeout(profit_loader, 5000);

	const zendesk_loader = () => {
		let script = document.createElement("script"); // Make a script DOM node
		script.id = "ze-snippet"
		script.src = "https://static.zdassets.com/ekr/snippet.js?key=3d4e0728-26b9-4a7d-acb7-021f7c80bf9c";
		script.defer = true
		document.body.appendChild(script);

		window.zESettings = {
			webWidget: {
				contactOptions: {
					enabled: true,
					contactButton: { '*': 'Contact us' },
					chatLabelOnline: { '*': 'Live chat' },
					contactFormLabel: { '*': 'Send us an email' }
				},
				chat: {
					connectOnPageLoad: true
				}
			}
		};

		if (typeof footerVars !== 'undefined') {
			if (footerVars.user !== 'false') {
				if (zE) {
					zE(function () {
						zE.identify({
							name: footerVars.firstName + ' ' + footerVars.lastName,
							email: footerVars.email
						});
					});
				} else {
					// console.warn('We tried to add identification of the current user for the Zendesk Widget, but looks like the Zendesk Widget script is not included on this page.');
				}
			}
		}
	}

	if (typeof footerVars !== 'undefined') {

		const chatbot_loader = () => {
			window.__be = window.__be || {};
			window.__be.id = footerVars.cbId;

			(function () {
				let be = document.createElement('script');
				be.type = 'text/javascript';
				be.async = true;
				be.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn.chatbot.com/widget/plugin.js';
				let s = document.getElementsByTagName('script')[0];
				s.parentNode.insertBefore(be, s);
			})();
		}

		if (footerVars.enableChatbot === '1') {
			if (loggedInStatus) {
				setTimeout(zendesk_loader, footerVars.zdTimeout);
			} else {
				setTimeout(chatbot_loader, footerVars.cbTimeout);

			}
		} else {
			setTimeout(zendesk_loader, footerVars.zdTimeout);
		}
	}

}

export default footerScripts;